export class PharmProcModel {
    method_of_issue?: string
    unit_per_issue?: number | null
    issue_container?: string
    code_fix?: string

    intLinkNo?: number
    intLinkType?: number
    strIType?: string
    lngPetNo?: number
    intAttending?: number
    lngSeq?: number
    strStatus?: string
    strUser?: string
    intUserNo?: number
    strLabelCode?: string
    Index?: number
    dispensedLater?: boolean | null

    constructor(
        method_of_issue: string,
        unit_per_issue: number | null,
        issue_container: string,
        code_fix: string,
        intLinkNo: number,
        intLinkType: number,
        strIType: string,
        lngPetNo: number,
        intAttending: number,
        lngSeq: number,
        strStatus: string,
        strUser: string,
        intUserNo: number,
        strLabelCode: string,
        Index: number,
        dispensedLater: boolean | null
    ) {
        this.method_of_issue = method_of_issue
        this.unit_per_issue = unit_per_issue
        this.issue_container = issue_container
        this.code_fix = code_fix
        this.intLinkNo = intLinkNo
        this.intLinkType = intLinkType
        this.strIType = strIType
        this.lngPetNo = lngPetNo
        this.intAttending = intAttending
        this.lngSeq = lngSeq
        this.strStatus = strStatus
        this.strUser = strUser
        this.intUserNo = intUserNo
        this.strLabelCode = strLabelCode
        this.Index = Index
        this.dispensedLater = dispensedLater
    }
}
